<template>
  <div class="z_index">
    <float-win
            v-if="Wintitle"
            :titleurl="{
              title: Wintitle,
              url: WinUrl,
            }"
          >
  </float-win>
    <div class="LeftImg" v-if="LeftImgShow">
      <!-- <a target=_blank href="javascript:void(0)"> -->
        <!-- <div
          style="
            cursor: pointer;
            text-align: right;
            font-size: 12px;
            color: #999999;
            display: inline-block;
            position: absolute;
            right: 5px;
            top: 2px;
          "
          @click="LeftImgShow = false"
        >
          关闭
        </div> -->
        <div>
          <!-- <div>
            <div class="LeftBoxTitle">
              业务咨询：
            </div>
            <div title="点击复制" @click="copyText('0575-88163055')" class="LeftBoxPhone">0575-88163055</div>
            <div title="点击复制" @click="copyText('0575-88163059')" class="LeftBoxPhone">0575-88163059</div>
          </div> -->
          <div>
            <div class="LeftBoxTitle">
              技术支持(非CA问题)：
            </div>
            <div title="点击复制" @click="copyText('0575-88163066')" class="LeftBoxPhone">0575-88163066</div>
          </div>
          <div>
            <div class="LeftBoxTitle">
              会员管理咨询电话：
            </div>
            <div title="点击复制" @click="copyText('0575-89295863')" class="LeftBoxPhone">0575-89295863</div>
          </div>
          <div>
            <div class="LeftBoxTitle">
              专家管理咨询电话：
            </div>
            <div title="点击复制" @click="copyText('0575-88021858')" class="LeftBoxPhone">0575-88021858</div>
          </div>
          <div>
            <div class="LeftBoxTitle">
              平台邮箱(发票咨询)：
            </div>
            <div title="点击复制" style="font-size: 13px;" @click="copyText('ygcgywwt@163.com')" class="LeftBoxPhone">ygcgywwt@163.com</div>
            <div style="font-weight: 600;font-size: 15px;">
              周一至周五<br> 8:30-12:00<br> 14:00-17:00<br>(节假日除外)
            </div>
          </div>
        </div>
      <!-- </a> -->
    </div>
    <div class="new">
      <!-- <span class="newtitle1"></span> -->
      <img class="newimg" src="../assets/img/Important.png"/>
      <!-- <span>
        <span> -->
        <el-carousel height="64px" style="width:1400px" direction="vertical" :autoplay="true" :interval="3000" >
          <el-carousel-item v-for="(item,index) of TopList" :key="index">
            <router-link v-if="item.articleId" :to="'/detail?articleId=' + item.articleId"><span class="newtitle2">{{item.title}}</span></router-link>
            <span class="newtime">{{GetDate(item.publishDate)}}</span>
          </el-carousel-item>
          <span v-if="TopList.length>1">
          <el-carousel-item v-for="(item,index) of TopList" :key="index">
            <router-link v-if="item.articleId" :to="'/detail?articleId=' + item.articleId"><span class="newtitle2">{{item.title}}</span></router-link>
            <span class="newtime">{{GetDate(item.publishDate)}}</span>
          </el-carousel-item>
          </span>
        </el-carousel>
    </div>
    <div class="Top">
        <el-carousel height="396px" :interval="5000" arrow="always">
          <!-- <el-carousel-item>
            <a target=_blank href="https://ygcg.jslink.com">
              <img class="LbImg" src="../assets/img/3.jpg">
            </a>
          </el-carousel-item> -->
          <el-carousel-item>
            <a target=_blank href="https://ec.cneptp.com/ZZMall/shaoxingzq/pages/index/index.html">
              <img class="LbImg" src="../assets/img/3.jpg">
            </a>
          </el-carousel-item>
          <!-- <el-carousel-item>
            <a target=_blank href="https://ygcg.sxjypt.com/detail?articleId=392">
              <img class="LbImg" src="../assets/img/2.jpg">
            </a>
          </el-carousel-item> -->
          <el-carousel-item>
            <img class="LbImg" src="../assets/img/1.jpg">
          </el-carousel-item>
          <el-carousel-item>
            <a target=_blank href="https://sxygcg.sxjypt.com/qytpframe">
              <!-- <img class="LbImg" src="../assets/img/20260831.png"> -->
              <!-- <img class="LbImg" src="../assets/img/001.jpg"> -->
              <!-- <img class="LbImg" src="../assets/img/002.jpg"> -->
              <!-- <img class="LbImg" src="../assets/img/003.jpg"> -->
              <img class="LbImg" src="../assets/img/004.jpg">
              <!-- <img class="LbImg" src="../assets/img/001.png"> -->
            </a>
          </el-carousel-item>
        </el-carousel>
        <div class="Topmenu">
            <ul>
            <li>
              <a target=_blank href="/ztb">
                <img src="../assets/img/CGR.png">
                采购人/招标人
              </a>
            </li>
            <li>
              <a target=_blank href="/wstb/login.html">
                <img src="../assets/img/TBR.png">
                供应商/投标人
              </a>
            </li>
            <li>
              <a target=_blank href="/ztb">
                <img src="../assets/img/DLJG.png">
                代理机构入口
              </a>
            </li>
            <li>
              <a target=_blank href="/expert/login.html?CustomerId=0000">
                <img src="../assets/img/ZJ.png">
                专家入口
              </a>
            </li>
            <li>
              <a target=_blank href="/ztb">
                <img src="../assets/img/PTGL.png">
                平台管理入口
              </a>
            </li>
            <li>
              <a target=_blank href="/sso/login?client_id=449abf125e27f3d8a3746004b59eb154&client_secret=d615b54a6ade7f99a119604fa32a75b6e765ee3cfea10d7bd8bf2530c6b691db&response_type=code&redirect_uri=https%3A%2F%2Fygcg.sxjypt.com%2Fztb%2FAuthorization%2FAuth.html&SystemName=电子监督系统">
                <img src="../assets/img/JG.png">
                监管入口
              </a>
            </li>
            <li>
              <a target=_blank href="/wspb">
                <img src="../assets/img/PB.png">
                评标入口
              </a>
            </li>
            <li>
              <a target=_blank href="/biddinglist?biddingType=0">
                <img src="../assets/img/WSJJ.png">
                网上竞价
              </a>
            </li>
            <li style="border: unset;">
              <a target=_blank href="/live">
                <img src="../assets/img/BJM.png">
                不见面开标
              </a>
            </li>
            <!-- <li>
              <a target=_blank href="https://ygcg.jslink.com">
                <img src="../assets/img/SC.png">
                小E商城
              </a>
            </li> -->
            </ul>
        </div>
    </div>
    <div class="Top1">
    <div class="Recentbid">
      <z-card
      :titleparam="{
        imgclass: 'Recentbid',
        title: '近期开标',
        morelink: './list?type=1&class=9'
      }"
      />
      <div style="text-align: right;">
        <router-link to="./list?type=1&class=9" style="font-size: 13px;color: #8C8C8C;font-weight: 400;text-decoration: none;margin-right: 36px;margin-top: 20px">更多 >></router-link>
      </div>
      <div class="RecentbidList">
        <div style="display:flex">
          <el-carousel height="203px" style="width:1430px" direction="vertical" :autoplay="true" :interval="3000" >
            <!-- <span> -->
            <el-carousel-item>
                <span v-for="(item,index) of OpenTenderOne" :key="index">
                  <router-link v-if="item.bulletinId!=undefined" :to="'/detail?bulletinId=' + item.bulletinId">
                    <div class="OpenPrj">
                      <div class="OpenPrjtitle">
                        <img src="../assets/img/fire.png">
                        {{item.prjName}}
                      </div>
                      <div class="KBName">{{item.roomName}}</div>
                      <div class="OpenPrjDate">
                        <img src="../assets/img/bell.png" style="margin-right:5px">
                        <span class="OpenPrjDateStr">开标时间：{{GetDateKB(item.kbDate)}}</span>
                      </div>
                    </div>
                    </router-link>
                </span>
            </el-carousel-item>
            <el-carousel-item v-if="OpenTenderTwo.length>0">
                <span v-for="(item,index) of OpenTenderTwo" :key="index">
                  <router-link v-if="item.bulletinId!=undefined" :to="'/detail?bulletinId=' + item.bulletinId">
                    <div class="OpenPrj">
                      <div class="OpenPrjtitle">
                        <img src="../assets/img/fire.png">
                        {{item.prjName}}
                      </div>
                      <div class="KBName">{{item.roomName}}</div>
                      <div class="OpenPrjDate">
                        <img src="../assets/img/bell.png" style="margin-right:5px">
                        <span class="OpenPrjDateStr">开标时间：{{GetDateKB(item.kbDate)}}</span>
                      </div>
                    </div>
                  </router-link>
                </span>
            </el-carousel-item>
            <el-carousel-item v-if="OpenTenderThree.length>0">
                <span v-for="(item,index) of OpenTenderThree" :key="index">
                  <router-link v-if="item.bulletinId!=undefined" :to="'/detail?bulletinId=' + item.bulletinId">
                    <div class="OpenPrj">
                      <div class="OpenPrjtitle">
                        <img src="../assets/img/fire.png">
                        {{item.prjName}}
                      </div>
                      <div class="KBName">{{item.roomName}}</div>
                      <div class="OpenPrjDate">
                        <img src="../assets/img/bell.png" style="margin-right:5px">
                        <span class="OpenPrjDateStr">开标时间：{{GetDateKB(item.kbDate)}}</span>
                      </div>
                    </div>
                  </router-link>
                </span>
            </el-carousel-item>
            <!-- </span> -->
          <!-- <span>
          <el-carousel-item v-for="(item,index) of TopList" :key="index">
            <router-link v-if="item.articleId" :to="'/detail?articleId=' + item.articleId"><span class="newtitle2">{{item.title}}</span></router-link>
            <span class="newtime">{{GetDate(item.publishDate)}}</span>
          </el-carousel-item>
          </span> -->
        </el-carousel>
      </div>
      </div>
    </div>
    </div>
    <div class="BiddingProcurement">
      <z-card
      :titleparam="{
        imgclass: 'Bidding',
        title: '交易信息'
      }"
      />
      <card-list
      :titleparam="{
          MenuList: menuList1,
          TopMenuList: topmenuList1,
      }"
      />
    </div>
    <!-- <div class="nonBiddingProcurement">
      <z-card
      :titleparam="{
        imgclass: 'nonBidding',
        title: '非招标采购'
      }"
      />
      <card-list
      :titleparam="{
          MenuList: menuList2,
          TopMenuList: topmenuList1,
          isZBCG:'2',
      }"
      />
    </div> -->
    <div class="dataSecnter">
      <z-card
        :titleparam="{
          imgclass: 'dataSecnter',
          title: '竞价大厅',
        }"
        />
      <div style="text-align: right;margin-top: -10px;margin-bottom: 10px;border-bottom: 1px solid #e4e7ed;">
        <div class="l_title">
            <div class="tabs">
              <span @click="QueryTabs(0)" :class="biddingType==0?'isactive':''">一次报价</span>
              <!-- <span @click="QueryTabs(1)" :class="biddingType==1?'isactive':''">多次报价</span> -->
              <!-- <span @click="QueryTabs(2)" :class="biddingType==2?'isactive':''">比选采购</span> -->
              <span @click="QueryTabs(3)" :class="biddingType==3?'isactive':''">竞价采购结果</span>
            </div>
        </div>
        <router-link to="./biddinglist?biddingType=0" style="font-size: 13px;color: #8C8C8C;font-weight: 400;text-decoration: none;">更多 >></router-link>
      </div>
        <div v-if="biddingType!=3" class="dataSecnterbox">
          <div class="BiddingBox" v-for="(item,index) of biddingList" :key="index">
          <span @click="item.bulletinId==null?Bullet(item.prjId):BulletN(item.bulletinId)">
          <div class="BiddingType">
            <span class="catalogue_span">
              <span v-if="item.ztbTypeId==='0207'"  :class="'z-tag D02'"
                >一次报价
              </span>
              <span v-if="item.ztbTypeId==='0208'"   :class="'z-tag D01'"
                >多次报价
              </span>
              <span v-if="item.ztbTypeId==='0210'"  :class="'z-tag D03'"
                >比选采购
              </span>
            </span>
            </div>
          <div class="BiddingTitle">{{item.prjName}}</div>
          <div class="BiddingSTitle">采购单位：<span>{{item.yzCompanyName}}</span></div>
          <div class="BiddingSTitle">预算价格：<span class="price">{{item.basePrice}}元</span></div>
          <div class="BiddingSTitle">品目分类：<span>{{item.callingName}}</span></div>
          <div class="BiddingSTitle">项目编号：<span>{{item.prjNo}}</span></div>
          </span>
          <div class="BiddingTime">
            <span>
              <img style="height: 23px;width: 23px;" src="../assets/img/BiddingBell.png">
              <span v-if="!getcountdown(item.kbDate).showcountdown||item.state==4">
                报价结束
              </span>
              <span v-else-if="item.state==6">
                已暂停
              </span>
              <span v-else>距报价结束
                <span>
                {{getcountdown(item.kbDate).days}}天
                {{getcountdown(item.kbDate).hours}}时
                {{getcountdown(item.kbDate).minutes}}分
                </span>
              </span>
            </span>
            <!-- <button @click="Bidding(item.prjId)">
              立即报价
            </button> -->
            <button v-if="getcountdown(item.kbDate).showcountdown&&item.state!==4" @click="Bidding(item.prjId)">
              立即报价
            </button>
          </div>
          </div>
        </div>
        <div v-else class="lista">
            <ul>
                <li v-for="(item,index) of biddingResult" :key="index">
                    <div class="listtitleR">
                      <router-link :to="'/detail??type=10&prjId='+item.prjId" >{{item.prjName}}</router-link>
                    </div>
                    <div>{{GetDate(item.closeDate)}}</div>
                </li>
            </ul>
        </div>
    </div>
    <div class="BiddingProcurement">
      <z-card
      :titleparam="{
        imgclass: 'Bidding',
        title: '非平台交易（公告代发）项目'
      }"
      />
      <card-list
      :titleparam="{
          MenuList: menuList2,
          TopMenuList: topmenuList2,
          isZBCG:'2',
      }"
      />
    </div>
    <div class="dataSecnter">
      <z-card
        :titleparam="{
          imgclass: 'dataSecnter',
          title: '数据中心',
        }"
        />
      <div class="DataCenterBox">
        <div class="DataCenterLeft">
          <div class="DataCenterLeftTitle">数据统计截止至：<span>{{Today}}</span></div>
          <div class="DataCenternum">
            <span class="DKB">
              <span class="Dvertical"></span>
              <span class="Dcontent">
                <span><span>{{Statistics.tobeopenedNumber}}</span>个</span>
                <span class="Dtitle">待开标数</span>
              </span>
            </span>
            <span class="JYXM">
              <span class="Dvertical"></span>
              <span class="Dcontent">
                <span><span>{{Statistics.count_project}}</span>个</span>
                <!-- <span><span>0</span>个</span> -->
                <span class="Dtitle">年度交易项目</span>
              </span>
            </span>
            <span class="JYZE">
              <span class="Dvertical"></span>
              <span class="Dcontent">
                <span><span>{{(Statistics.count_money/10000).toFixed(2)}}</span>亿元</span>
                <span class="Dtitle">年度交易总额</span>
              </span>
            </span>
          </div>
          <div class="DataCenterimg">
              <!-- <img src="../assets/img/绍兴市.png"> -->
              <Map></Map>
          </div>
        </div>
        <div class="DataCenterRight">
          <div class="DataCenterRightTitle">今日交易统计</div>
          <div class="DataCenterRnum">
            <span class="JRRC">
              <span><span>{{Statistics.today_bulletin}}</span>宗</span>
              <span class="LTitle">今日入场数</span>
            </span>
            <span class="JRGG">
              <span><span>{{Statistics.today_bulletin}}</span>条</span>
              <span class="LTitle">今日公告数</span>
            </span>
            <span class="JRKB">
              <span><span>{{ Statistics.today_open }}</span>宗</span>
              <span class="LTitle">今日开标数</span>
            </span>
            <span class="JRPB">
              <span><span>{{ Statistics.today_pb }}</span>宗</span>
              <span class="LTitle">今日评标数</span>
            </span>
            <span class="JRCJ">
              <span><span>{{ Statistics.today_cj }}</span>条</span>
              <span class="LTitle">今日成交数</span>
            </span>
            <span class="JRHY">
              <span><span>{{Statistics.count_member}}</span>家</span>
              <span class="LTitle">今日会员数</span>
            </span>
          </div>
          <div class="DataCenterRightTitle" style="margin-top:40px">电子监督统计(年度)</div>
          <div class="Electronic">
            <div>
              <img style="width: 74px;height: 74px;" src="../assets/img/DZJLALL.png">
              <div>
                <span>电子监督-总计</span>
                <span><span>{{DZJGList.total}}</span>条</span>
              </div>
            </div>
            <div>
              <img style="width: 74px;height: 74px;" src="../assets/img/DZGREEN.png">
              <div>
                <span>电子监督-绿灯</span>
                <span><span id="DZGREEN">{{DZJGList.greenTotal}}</span>条</span>
              </div>
            </div>
            <div>
              <img style="width: 74px;height: 74px;" src="../assets/img/DZYELLOW.png">
              <div>
                <span>电子监督-黄灯</span>
                <span><span id="DZYELLOW">{{DZJGList.yellowTotal}}</span>条</span>
              </div>
            </div>
            <div>
              <img style="width: 74px;height: 74px;" src="../assets/img/DZRED.png">
              <div>
                <span>电子监督-红灯</span>
                <span><span id="DZRED">{{DZJGList.redTotal}}</span>条</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dataSecnter">
      <z-card
        :titleparam="{
          imgclass: 'dataSecnter',
          title: '综合动态',
        }"
        />
        <div class="TrendsBox">
          <div>
            <div class="Notice trends">
              <span class="trendsTitle">通知动态</span>
              <span>
                <router-link to="/list?type=0&class=2&categoryId=02" >查看更多></router-link>
              </span>
            </div>
            <!-- PlatformNews -->
            <div class="trendsList" v-for="(item,index) of PlatformNews" :key="index">
              <div class="listtitle"><span style="color: #2578E0;font-size:16px;margin-right:10px">✦</span><router-link :to="'/detail?articleId='+item.articleId" >{{item.title}}</router-link></div>
              <div class="trendsDate" v-if="index==0" style="height:50px">
                <span v-html="item.shortContent!=null?item.shortContent:item.title"></span>
              </div>
              <div class="trendsDate">
                {{GetDate(item.publishDate)}}
              </div>
            </div>
          </div>
          <div>
            <div class="News trends">
              <span class="trendsTitle">新闻动态</span>
              <span>
                <router-link to="/list?type=5&class=10" >查看更多></router-link>
              </span>
            </div>
            <div class="trendsList" v-for="(item,index) of newsList" :key="index">
              <div class="listtitle"><span style="color: #2578E0;font-size:16px;margin-right:10px">✦</span><router-link :to="'/detail?newsId='+item.articleId" >{{item.title}}</router-link></div>
              <div class="trendsDate" v-if="index==0" style="height:50px">
                <span v-html="item.shortContent!=null?item.shortContent:item.title"></span>
              </div>
              <div class="trendsDate">
                {{GetDate(item.publishDate)}}
              </div>
            </div>
          </div>
          <div>
            <div class="Policy trends">
              <span class="trendsTitle">政策法规</span>
              <span>
                <router-link to="/list?type=0&class=4&categoryId=05" >查看更多></router-link>
              </span>
            </div>
            <div class="trendsList" v-for="(item,index) of REGUList" :key="index">
              <div class="listtitle"><span style="color: #2578E0;font-size:16px;margin-right:10px">✦</span><router-link :to="'/detail?articleId=' + item.articleId">{{item.title}}</router-link></div>
              <div class="trendsDate" v-if="index==0" style="height:50px">
                <span v-html="item.shortContent!=null?item.shortContent:item.title"></span>
              </div>
              <div class="trendsDate">
                {{GetDate(item.publishDate)}}
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ZCard from '../components/card'
import CardList from '../components/cardlist'
import FloatWin from '../components/FloatWin/FloatWin'
import Map from '../components/Map'
import { mapMutations } from 'vuex'
import {
  GetPortalInfo,
  GetPortalInfoList1,
  GetPortalInfoList2,
  // GetPortalInfoList3,
  GetPortalInfoList4,
  GetBulletinList,
  GetPurchaseResults,
  GetBiddingHall
} from '@/api/Home'
import { GetListByCategoryId } from '@/api/article'
import { GetHomeOpenList } from '@/api/protal'
import moment from 'moment'
export default {
  data () {
    return {
      LeftImgShow: true,
      Wintitle: '',
      WinUrl: '',
      biddingType: 10,
      moveup: 0,
      move: null,
      topmove: null,
      OpenTenderOne: [],
      OpenTenderTwo: [],
      OpenTenderThree: [],
      biddingList: [],
      biddingResult: [],
      newsList: [],
      menuList1: [
        {
          name: '采购公告',
          code: '21'
        },
        {
          name: '变更公告',
          code: '23'
        },
        {
          name: '候选人公示',
          code: '22'
        },
        {
          name: '结果公告',
          code: '24'
        },
        {
          name: '采购文件预公示',
          code: '20'
        },
        {
          name: '异常公告',
          code: '26'
        },
        {
          name: '其他公告',
          code: '29'
        }
      ],
      // 001002001
      menuList2: [
        {
          name: '招标公告',
          code: '001'
        },
        {
          name: '变更公告',
          code: '002'
        },
        {
          name: '开标记录',
          code: '006'
        },
        {
          name: '候选人公示',
          code: '003'
        },
        {
          name: '结果公示',
          code: '004'
        },
        {
          name: '其他公告',
          code: '005'
        }
      ],
      topmenuList1: [
        {
          name: '全部',
          code: null
        },
        {
          name: '工程',
          code: 'D02'
        },
        {
          name: '货物',
          code: 'D01'
        },
        {
          name: '服务',
          code: 'D03'
        },
        {
          name: '其他',
          code: 'D04'
        }
      ],
      topmenuList2: [
        {
          name: '招标采购',
          code: '001002001'
        },
        {
          name: '非招标采购',
          code: '001002002'
        }
      ],
      TopList: [],
      BulletinList: [],
      PlatformNews: [],
      REGUList: [],
      DZJGList: [],
      Statistics: [],
      TopArticletitle: '',
      TopArticleUrl: '',
      TopArticleDate: '',
      Today: ''
    }
  },
  components: {
    ZCard,
    CardList,
    Map,
    FloatWin
  },
  methods: {
    ...mapMutations(['SET_NAV_NAME']),
    Bidding (prjId) {
      window.open('/wstb/login.html?PrjId=' + prjId, '_blank')
    },
    getnowTime () {
      var date = new Date()
      var year = date.getFullYear() // 月份从0~11，所以加一
      let month = date.getMonth()
      console.log('month', month)
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      ]
      // 如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = '0' + dateArr[i]
        }
      }
      this.Today =
      year +
      '年' +
      dateArr[0] +
      '月' +
      dateArr[1] +
      '日'
      // 此处可以拿外部的变量接收，也可直接返回  strDate:2022-05-01 13:25:30
      // this.date = strDate;
    },
    getcountdown (kbDate) {
      var date = moment(kbDate)
      var now = moment()
      let start = moment(new Date())
      let end = moment(new Date(kbDate))
      let result = {
        showcountdown: false
      }
      if (now < date) {
        let diff = end.diff(start)
        let days = moment.duration(diff).days()
        let hours = moment.duration(diff).hours()
        let minutes = moment.duration(diff).minutes()
        result.days = days > 9 ? days : '0' + days
        result.hours = hours
        result.minutes = minutes
        result.showcountdown = true
        return result
      } else {
        return result
      }
    },
    GetDate (date) {
      var day = ''
      if (date) {
        day = date.slice(0, 10)
      }
      return day
    },
    GetDateKB (date) {
      var day = ''
      if (date) {
        day = date.slice(0, 10) + ' ' + date.slice(11, 19)
      }
      return day
    },
    GetDateMD (date) {
      var day = ''
      if (date) {
        day = date.slice(2, 10)
      }
      return day
    },
    GetDateT (date) {
      var day = ''
      if (date) {
        day = date.slice(12, 16)
      }
      return day
    },
    GetDateD (date) {
      var day = ''
      if (date) {
        day = date.slice(8, 10)
      }
      return day
    },
    GetDateM (date) {
      var month = ''
      if (date) {
        month = date.slice(0, 7)
      }
      return month
    },
    GetPortalInfo () {
      let param = {
      }
      let listparam = {
        pageIndex: 1,
        pageSize: 600
      }
      let Categoryparam = {
        pageIndex: 1,
        pageSize: 5,
        categoryId: '0501'
      }
      let Bulletparam1 = {
        InfoTypeId: null,
        ZtbTypeId: null,
        classID: '21',
        pageIndex: 1,
        pageSize: 8
      }
      GetPortalInfo(param).then((res) => {
        console.log(res)
        this.PlatformNews = res.data.articleList_02_PlatformNews.articleList
        this.TopList = res.data.topArticleList.articleList
        this.Wintitle = res.data.floatArticle.title
        this.WinUrl = '/detail?articleId=' + res.data.floatArticle.articleId
      })
      GetPortalInfoList1(param).then((res) => {
        this.biddingList = res.data.biddingList_Project0207.projectList
        this.QueryTabs(0)
        this.newsList = res.data.newsList.body.data
      })
      GetPortalInfoList2(param).then((res) => {
        this.DZJGList = res.data.superviseLight
      })
      GetPortalInfoList4(param).then((res) => {
        this.Statistics = res.data.hP_Statistics
      })
      GetHomeOpenList(listparam).then((res) => {
        this.OpenTenderOne = res.data.projectListOne
        this.OpenTenderTwo = res.data.projectListTwo
        this.OpenTenderThree = res.data.projectListThree
      })
      GetBulletinList(Bulletparam1).then((res) => {
        this.BulletinList = res.data.bulletinList
      })
      GetListByCategoryId(Categoryparam).then((res) => {
        this.REGUList = res.data.articleList
      })
    },
    Bullet (prjId) {
      this.$router.push({
        path: '/detail',
        query: { type: 1, prjId: prjId }
      })
    },
    BulletN (bulletinId) {
      this.$router.push({
        path: '/detail',
        query: { bulletinId: bulletinId }
      })
    },
    QueryTabs (tab) {
      this.biddingType = tab
      this.Query()
    },
    Query () {
      let param = {}
      param.pageIndex = 1
      param.pageSize = 6
      param.classID = '22'
      if (this.biddingType === 0) {
        param.ztbTypeId = '0207'
      } else if (this.biddingType === 1) {
        param.ztbTypeId = '0208'
      } else if (this.biddingType === 2) {
        param.ztbTypeId = '0210'
      }
      this.biddingList = []
      if (this.biddingType !== 3) {
        GetBiddingHall(param).then((res) => {
          this.biddingList = res.data.projectList
        })
      } else {
        let _param = {}
        _param.pageIndex = 1
        _param.pageSize = 10
        GetPurchaseResults(_param).then((res) => {
          this.biddingResult = res.data
        })
      }
    },
    copyText (phone) {
      const textToCopy = phone
      navigator.clipboard.writeText(textToCopy).then(() => {
        console.log('文本已复制到剪贴板')
      }, (err) => {
        console.error('复制失败', err)
      })
    }
  },
  mounted () {
    this.getnowTime()
    this.SET_NAV_NAME('首页')
    this.GetPortalInfo()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.z_index{
  text-align: center;
}
.listtitle a{
    color: black;
    text-decoration: none;
}
.listtitle a:hover{
    color: #4e4e4e;
    text-decoration: none;
}
.tabs{
  display: flex;
  position: absolute;
  /* right: 300px; */
  margin-top: -12.5px;
  z-index: 1;
}
.tabs>span{
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  border: 1px solid #e4e7ed;
  font-size: 14px;
  /* border-right: 0px; */
  cursor: pointer;
  width: 85px;
  text-align: center;
  background-color:white;
}
.tabs>span:nth-child(4){
  border-right: 1px solid #e4e7ed;
}
.isactive{
  border-bottom: 1px solid #FFFFFF!important;
  color: #409eff;
  font-weight: 600;
}
.lista{
  min-height: 266px;
}
.lista ul{
    list-style-type: none;
    padding: 0;
}
.lista li{
    width: 100%;
    border-bottom: 1px solid #e8e8e8;
    padding: 8px 0;
    display: flex;
    justify-content: space-around;
    font-size: 18px;
}
.lista li>div{
    line-height: 21px;
    height: 21px;
}
.listtitleR{
    width: calc(100% - 150px);
    text-align: left;
    color: black;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}
.listtitleR a{
    color: black;
    text-decoration: none;
}
.listtitleR a:hover{
    color: #4e4e4e;
    text-decoration: none;
}
.LeftImg{
  position: fixed;
  z-index: 99999999;
  /* width: 200px; */
  width: 141px;
  bottom: calc(50% - 140px);
  cursor: pointer;
  background: #a7c1ff;
  /* a7c1ff */
  /* 3670fe */
  text-align: left;
  padding: 20px;
  border-radius: 8px;
  /* padding-top: 60px; */
  padding-top: 30px;
}
.LeftImg img{
  width: 200px;
}
.LbImg{
  height: 396px;
  width: 1903px;
}
</style>
<style>
.el-carousel__arrow--left{
  left: 256px!important;
  font-size: 36px!important;
}
.el-carousel__arrow--right, .el-notification.right{
  right: 256px!important;
  font-size: 36px!important;
}
.LeftBoxTitle{
  font-weight: bolder;
  /* font-size: 22px; */
  font-size: 13px;
  color: #000;
  margin-bottom: 15px;
}
.LeftBoxPhone{
  color: #fff;
  font-weight: bolder;
  font-size: 16px;
  padding-bottom: 10px;
  margin-bottom: 15px;
  border-bottom: #fff dashed 1px;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue